import { gql } from '@apollo/client';

export const GET_BOOKINGS = gql`
  query GetBookingsByDate($year: Float!, $month: Float!, $date: Float!) {
    getBookingsByDate(year: $year, month: $month, date: $date) {
      id
      coachId
      clientId
      date
      duration
      meetingLink
      createdAt
      updatedAt
      coach {
        id
        firstName
        lastName
      }
      clientFirstName
      clientLastName
      clientEmail
      clientPhone
      servicePackageId
      isAgreedToTerms
      isSubscribedToNewsletter
      bookingStatus
      servicePackage {
        id
        title
        sessionPrice
        sessionDuration
        sessionDescription
        coachId
        bookingType
      }
      referenceText
      referenceNote
    }
  }
`;

export const GET_BOOKINGS_FOR_MONTH = gql`
  query GetBookingsByMonth($month: Float!, $year: Float!) {
    getBookedDatesPerMonth(month: $month, year: $year) {
      date
    }
  }
`;

export const CREATE_COACH_AVAILABILITY = gql`
  mutation CreateCoachAvailability(
    $coachId: String!
    $availabilities: [CoachAvailabilityInput!]!
    $activeStep: Float
  ) {
    createCoachAvailability(
      createCoachAvailabilityInput: {
        coachId: $coachId
        availabilities: $availabilities
        activeStep: $activeStep
      }
    ) {
      message
    }
  }
`;

export const UPDATE_COACH_AVAILABILITY = gql`
  mutation UpdateCoachAvailability(
    $coachId: String!
    $availabilities: [CoachAvailabilityInput!]!
    $activeStep: Float
  ) {
    updateCoachAvailability(
      updateCoachAvailabilityInput: {
        coachId: $coachId
        availabilities: $availabilities
        activeStep: $activeStep
      }
    ) {
      message
    }
  }
`;

export const GET_GOOGLE_CALENDAR_AUTH_URI = gql`
  query GetGoogleCalendarAuthURI {
    getGoogleCalendarAuthURI
  }
`;

export const GET_OUTLOOK_CALENDAR_AUTH_URI = gql`
  query GetOutLookCalendarAuthURI {
    getOutLookCalendarAuthURI
  }
`;

export const SAVE_LINKED_CALENDAR = gql`
  mutation SaveCalendar(
    $coachId: String!
    $calendar: Calendar!
    $activeStep: Float
    $calendarUsername: String!
  ) {
    saveCalendar(
      calendarInput: {
        coachId: $coachId
        calendar: $calendar
        activeStep: $activeStep
        calendarUsername: $calendarUsername
      }
    ) {
      id
      calendar
      calendarUsername
      activeStep
    }
  }
`;

export const SAVE_VIDEOCALL_PLATFORM = gql`
  mutation saveVideoCallPlatForm(
    $coachId: String!
    $videoCallPlatform: VideoCallPlatform!
    $activeStep: Float
    $videoCallPlatformUsername: String!
  ) {
    saveVideoCallPlatForm(
      saveVideoCallPlatForm: {
        coachId: $coachId
        videoCallPlatform: $videoCallPlatform
        activeStep: $activeStep
        videoCallPlatformUsername: $videoCallPlatformUsername
      }
    ) {
      id
      videoCallPlatform
      videoCallPlatformUsername
      activeStep
    }
  }
`;

export const SAVE_CONSULTATION_PREFERENCE = gql`
  mutation SaveConsultationPreference(
    $coachId: String!
    $isProvideOnlineConsultations: Boolean!
    $videoCallPlatform: VideoCallPlatform
    $activeStep: Float!
    $isProvideInPersonConsultations: Boolean
    $videoCallPlatformUsername: String
  ) {
    saveConsultationPreference(
      SaveConsultationPreference: {
        coachId: $coachId
        isProvideOnlineConsultations: $isProvideOnlineConsultations
        videoCallPlatform: $videoCallPlatform
        activeStep: $activeStep
        isProvideInPersonConsultations: $isProvideInPersonConsultations
        videoCallPlatformUsername: $videoCallPlatformUsername
      }
    ) {
      coachId
      videoCallPlatform
      activeStep
      createdAt
      updatedAt
      isProvideOnlineConsultations
      isProvideInPersonConsultations
      calendar
      makeAddressPublic
      makePhonePublic
      calendarUsername
      videoCallPlatformUsername
      url
      officeAddress
      officePhone
    }
  }
`;

export const CHECK_TOKEN_EXISTS = gql`
  query CheckTokenExists($coachId: String!, $tokenType: String!) {
    checkTokenExists(checkTokenExistsInput: { coachId: $coachId, tokenType: $tokenType }) {
      isTokenExist
      userName
    }
  }
`;

export const GET_COACH_CONFIGURATIONS = gql`
  query GetCoachConfigurations($coachId: String!) {
    getCoachConfigurations(coachId: $coachId) {
      id
      coachId
      activeStep
      videoCallPlatform
      isProvideOnlineConsultations
      isProvideInPersonConsultations
      calendar
      makeAddressPublic
      makePhonePublic
      hasBookings
      calendarUsername
      videoCallPlatformUsername
      url
      officeAddress
      officePhone
    }
  }
`;

export const SAVE_COACH_OFFICE_DETAILS = gql`
  mutation saveCoachOfficeDetails(
    $coachId: String!
    $officeAddress: String!
    $activeStep: Float!
    $officeCountry: String
    $officePhone: String
    $makeAddressPublic: Boolean
    $makePhonePublic: Boolean
    $isProvideInPersonConsultations: Boolean!
    $isProvideOnlineConsultations: Boolean
  ) {
    saveCoachOfficeDetails(
      coachOfficeDetailsInput: {
        coachId: $coachId
        officeAddress: $officeAddress
        activeStep: $activeStep
        officeCountry: $officeCountry
        officePhone: $officePhone
        makeAddressPublic: $makeAddressPublic
        makePhonePublic: $makePhonePublic
        isProvideInPersonConsultations: $isProvideInPersonConsultations
        isProvideOnlineConsultations: $isProvideOnlineConsultations
      }
    ) {
      success
      message
    }
  }
`;

export const SAVE_BOOKING_PAGE_URL = gql`
  mutation SaveBookingUrl($coachId: String!, $url: String!, $activeStep: Float!) {
    saveBookingUrl(bookingUrlInput: { coachId: $coachId, url: $url, activeStep: $activeStep }) {
      id
    }
  }
`;

export const GET_COACH_AVAILABILITIES = gql`
  query GetCoachAvailabilities($coachId: String!) {
    findCoachAvailabilities(coachId: $coachId) {
      id
      startTime
      endTime
      dayOfWeek
    }
  }
`;

export const DELETE_CALENDAR = gql`
  mutation DeleteCalendar($calenderType: String!) {
    deleteCalendar(calenderType: $calenderType) {
      message
      success
      statusCode
    }
  }
`;

export const DELETE_TOKENS = gql`
  mutation deleteTokens(
    $tokenType: TokenType!
    $clearCalendar: Boolean!
    $clearVideoPlatform: Boolean!
  ) {
    deleteTokens(
      deleteTokenInputs: {
        tokenType: $tokenType
        clearCalendar: $clearCalendar
        clearVideoPlatform: $clearVideoPlatform
      }
    ) {
      message
      success
      statusCode
    }
  }
`;

export const GET_ZOOM_AUTH_URI = gql`
  query GetZoomAuthURI {
    getZoomAuthURI
  }
`;

export const CHECK_URL_EXISTENCE = gql`
  query checkUrlExistence($checkUrlExistenceArgs: CheckUrlExistenceInput!) {
    checkUrlExistence(checkUrlExistenceArgs: $checkUrlExistenceArgs) {
      success
    }
  }
`;

export const CANCEL_BOOKING = gql`
  mutation cancelBooking($id: Float!) {
    cancelBooking(id: $id) {
      id
      bookingStatus
    }
  }
`;

export const GET_RESCHEDULE_TIME_SLOTS = gql`
  query getRescheduleTimes($bookingId: Float!, $date: Float!, $month: Float!, $year: Float!) {
    getRescheduleTimes(bookingId: $bookingId, date: $date, month: $month, year: $year) {
      date
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation rescheduleBooking($date: DateTime!, $bookingId: Float!, $servicePackageId: String!) {
    rescheduleBooking(date: $date, bookingId: $bookingId, servicePackageId: $servicePackageId) {
      id
      coachId
      clientId
      date
      duration
      meetingLink
      createdAt
      updatedAt
      clientFirstName
      clientLastName
      clientEmail
      clientPhone
      servicePackageId
      isAgreedToTerms
      isSubscribedToNewsletter
      bookingStatus
      servicePackage {
        id
        title
        sessionPrice
        sessionDuration
        sessionDescription
        coachId
        bookingType
      }
      referenceText
      referenceNote
    }
  }
`;

export const UPDATE_COACH_ACTIVE_STEP = gql`
  mutation updateCoachActiveStep($activeStep: Float!) {
    updateCoachActiveStep(activeStep: $activeStep) {
      id
      activeStep
    }
  }
`;
